import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { TIME_PERIOD_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PERIOD } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { CUSTOM } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { EMAIL_SCREEN, SELECT_PERIOD_SCREEN } from 'apps/auth/constants/Constants';
import { END_DATE_CAMELCASE, START_DATE_CAMELCASE } from 'apps/auth/constants/fieldsName';
import { TRANSFER_STATEMENT } from 'apps/auth/constants/formName';
import { getDDMMYYYYNumericDate, resolveArguments } from 'apps/auth/helpers/utils';
import { useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const StatementListScreen = (props) => {
    const { lang } = useLanguage();
    const { getTransferStatement, selectPeriod, statementFromTo, statement_1_month, statement_3_month, statement_6_month, statement_12_month } =
        usePageMessages();

    const statementPeriod = {
        [statement_1_month]: 1,
        [statement_3_month]: 3,
        [statement_6_month]: 6,
        [statement_12_month]: 12,
    };

    const getDateForView = (lang = 'en', months) => {
        const currentDate = new Date();
        const pastDate = new Date(currentDate);
        pastDate.setMonth(pastDate.getMonth() - months);
        pastDate.setDate(pastDate.getDate() + 1);

        const formatDate = (date) => {
            const day = new Intl.DateTimeFormat(lang, { day: 'numeric' }).format(date);
            const month = new Intl.DateTimeFormat(lang, { month: 'short' }).format(date);
            return `${day} ${month}`;
        };
        const formattedPastDate = formatDate(pastDate);
        const formattedCurrentDate = formatDate(currentDate);

        return [formattedPastDate, formattedCurrentDate];
    };

    const getEndDate = () => {
        const currentDate = new Date();
        return getDDMMYYYYNumericDate(currentDate);
    };

    const getStartDate = (months) => {
        const pastDate = new Date();
        pastDate.setMonth(pastDate.getMonth() - months);
        pastDate.setDate(pastDate.getDate() + 1);
        return getDDMMYYYYNumericDate(pastDate);
    };

    const sendAmplitudeEvent = (period) => {
        const periodParam = period || CUSTOM;
        amplitude.getInstance().logEvent(TIME_PERIOD_CLICKED, {
            [PERIOD]: periodParam,
        });
    };

    return (
        <>
            <HeaderPanel title={getTransferStatement} />
            {Object.keys(statementPeriod).map((key) => {
                return (
                    <Row key={key} indent="adaptive-24-32">
                        <Panel
                            onClick={() => {
                                sendAmplitudeEvent(statementPeriod[key]);
                                props.switchToNextScreen(EMAIL_SCREEN);
                                props.changeFormFieldValue(TRANSFER_STATEMENT, getStartDate(statementPeriod[key]), START_DATE_CAMELCASE);
                                props.changeFormFieldValue(TRANSFER_STATEMENT, getEndDate(), END_DATE_CAMELCASE);
                                props.setIsCustomPeriod(false);
                            }}
                            isBordered
                            hasBorderRadius
                            isHoverable
                        >
                            <PanelContent>
                                <Text variant="div" indent="4px">
                                    {key}
                                </Text>
                                <Text size="secondary" color="secondary">
                                    {resolveArguments(statementFromTo, getDateForView(lang, statementPeriod[key]))}
                                </Text>
                            </PanelContent>
                        </Panel>
                    </Row>
                );
            })}
            <Row indent="adaptive-24-32">
                <Panel
                    onClick={() => {
                        sendAmplitudeEvent();
                        props.setIsCustomPeriod(true);
                        props.switchToNextScreen(SELECT_PERIOD_SCREEN);
                    }}
                    isBordered
                    hasBorderRadius
                    isHoverable
                >
                    <Text>{selectPeriod}</Text>
                </Panel>
            </Row>
        </>
    );
};

StatementListScreen.propTypes = {
    switchToNextScreen: PropTypes.func.isRequired,
    setIsCustomPeriod: PropTypes.func.isRequired,
};

export default connect(null, { changeFormFieldValue })(StatementListScreen);
